import React from 'react';
import { useDispatch } from 'react-redux';
import { startGoogleLogin } from '../../actions/auth';

export const LoginScreen = () => {
    const dispatch = useDispatch();

    const handleGoogleLogin = () => {
        dispatch(startGoogleLogin());
    };

    return (
        <div className="app-container">
            <div className="login-screen">
                <div className="login-logo">
    <svg width="80" height="80" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <rect x="0" y="0" width="512" height="512" rx="115" fill="#CE4979" />
        <circle cx="256" cy="150" r="20" fill="#FFFFFF" />
        <path d="M134 290 A122 122 0 0 1 378 290 Z" fill="#FFFFFF" />
        <rect x="104" y="286" width="304" height="32" rx="16" fill="#FFFFFF" />
        <circle cx="256" cy="346" r="18" fill="#FFFFFF" />
        <path d="M398 150 C398 182 411 195 443 195 C411 195 398 208 398 240 C398 208 385 195 353 195 C385 195 398 182 398 150 Z" fill="#F4B6D0" />
    </svg>
</div>
                <h1 className="login-title">Revi</h1>
                <p className="login-sub">
                    Tu recepcionista virtual de belleza.<br />
                    Recibe citas por WhatsApp 24/7,<br />
                    sin que tengas que hacer nada.
                </p>

                <button className="btn-google" onClick={handleGoogleLogin}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="10" fill="white" />
                        <path d="M10 4.5a5.5 5.5 0 1 0 3.89 9.39L12.5 12.5A3.5 3.5 0 1 1 10 6.5V4.5z" fill="#D4537E" />
                    </svg>
                    Entrar con Google
                </button>

                <p style={{ fontSize: 12, color: 'var(--pink-800)', marginTop: 20, lineHeight: 1.6 }}>
                    Necesitas una cuenta de Google para<br />
                    conectar tu calendario de citas
                </p>
            </div>
        </div>
    );
};